import { type SVGProps } from "react";

export const AppleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}>
    <path
      fill="#000"
      d="M16.232 1h.157c.125 1.551-.467 2.71-1.187 3.55-.706.834-1.673 1.643-3.237 1.52-.104-1.53.489-2.603 1.208-3.44.666-.78 1.888-1.475 3.06-1.63ZM20.967 17.149v.043c-.44 1.331-1.066 2.472-1.832 3.531-.698.961-1.554 2.255-3.082 2.255-1.32 0-2.198-.85-3.552-.873-1.431-.023-2.218.71-3.528.895h-.446c-.961-.14-1.737-.9-2.302-1.586-1.666-2.027-2.954-4.645-3.194-7.995v-.985c.102-2.397 1.267-4.347 2.815-5.292.818-.502 1.941-.93 3.192-.739.536.083 1.084.267 1.564.448.455.175 1.024.485 1.563.469.366-.01.729-.201 1.097-.335 1.078-.39 2.135-.836 3.528-.626 1.674.253 2.862.997 3.597 2.144-1.417.902-2.536 2.26-2.345 4.58.17 2.106 1.395 3.34 2.925 4.066Z"
    />
  </svg>
);
